import { useMemo, useState } from 'react';
import useLoadReclamations from './functions/useLoadReclamations';
import useSearches from './functions/useSearches';

export default function useReclamations() {
  const [currentPage, setCurrentPage] = useState(1);
  const [listView, setListView] = useState<'card' | 'table'>('card');

  const {
    isLoadLoading,
    doesListApiHasError,
    fullReclamations,
    reclamationsSplitted,
    filteredReclamations,
    loadReclamations,
    setReclamationsSplitted,
    setFilteredReclamations,
  } = useLoadReclamations({ setCurrentPage });

  const {
    searchTerm,
    onChangeSearchTerm,
  } = useSearches({
    fullReclamations,
    setReclamationsSplitted,
    setFilteredReclamations,
  });

  const pagesQuantity = useMemo(() => reclamationsSplitted.length, [reclamationsSplitted.length]);

  function handlePageChange(page: number) {
    setCurrentPage(page);
    setFilteredReclamations(reclamationsSplitted[page]);
  }

  function handleTryAgain() {
    loadReclamations();
  }

  const isLoading = isLoadLoading;

  return {
    isLoading,
    fullReclamations,
    doesListApiHasError,
    filteredReclamations,
    currentPage,
    pagesQuantity,
    handlePageChange,
    handleTryAgain,
    listView,
    setListView,
    searchTerm,
    onChangeSearchTerm,
  };
}
